// Componente: EditDatosPersonales.jsx (basado en estructura JSON)
import React from "react";
import Input from "../../../Elements/Input/Input";

const EditDatosPersonales = ({ values, handleChange }) => {
    return (
        <div className="seccion-formulario">
            <h4>Datos Personales</h4>
            <div className="row g-3">
                {/* <div className="col-md-6">
                    <Input value={values.numeroEmpleado} label="No. Empleado" disabled />
                </div> */}
                <div className="col-md-6">
                    <Input value={values.nombre} label="Nombre" onChange={handleChange("nombre")} />
                </div>
                <div className="col-md-6">
                    <Input value={values.apellidoPaterno} label="Apellido paterno" onChange={handleChange("apellidoPaterno")} />
                </div>
                <div className="col-md-6">
                    <Input value={values.apellidoMaterno} label="Apellido materno" onChange={handleChange("apellidoMaterno")} />
                </div>
                <div className="col-md-6">
                    <Input value={values.curp} label="CURP" onChange={handleChange("curp")} />
                </div>
                <div className="col-md-6">
                    <Input value={values.rfc} label="RFC" onChange={handleChange("rfc")} />
                </div>
                <div className="col-md-6">
                    <Input
                        value={values.fechaNacimiento}
                        label="Fecha de nacimiento"
                        type="date"
                        onChange={handleChange("fechaNacimiento")}
                    />
                </div>
                <div className="col-md-6">
                    <Input
                        value={values.numeroSeguroSocial}
                        label="Número de seguro social"
                        onChange={handleChange("numeroSeguroSocial")}
                    />
                </div>
                <div className="col-md-6">
                    <Input
                        value={values.gradoEstudios}
                        label="Grado de estudios"
                        onChange={handleChange("gradoEstudios")}
                    />
                </div>
            </div>
        </div>
    );
};

export default EditDatosPersonales;
